import React from 'react';
import PreDeliveringContainer from './PreDeliveringContainer';
import { createdSourceList, KICK_AVENUE_SOURCE } from '../../../constants/kickavenue';

// This tab is scoped to KICK_AVENUE, so its "All" means every Kick Avenue
// Pre-Delivering sale rather than every source. The remaining options are the two
// ways a Kick Avenue sale can be created, so the operator can narrow the tab down
// at creation-source level. Other pages keep the full salesCreatedSourceList.
const createdSourceOptions = [
  { name: 'All', value: KICK_AVENUE_SOURCE },
  ...createdSourceList,
];

const KickAvenue = (props) => (
  <PreDeliveringContainer
    createdSource={KICK_AVENUE_SOURCE}
    showCreatedSourceFilter
    createdSourceOptions={createdSourceOptions}
    analyticsPageName="kick_avenue_pre_delivering_sales"
    title="Kick Avenue Pre-Delivering List"
    {...props}
  />
);

export default KickAvenue;
